import { useParams } from 'react-router-dom';
import type { EnvironmentKey } from '@web-config-app/core';

export interface ConfigAppParams {
  tenantId?: string;
  tabId?: string;
  moduleId?: string;
  /** Present when the target module is inside a container */
  childModuleId?: string;
  environmentKey?: EnvironmentKey;
  entityInstanceId?: string;
}

export function useConfigAppParams<
  Params extends { [K in keyof Params]?: string } = ConfigAppParams,
>() {
  const params = useParams<Params>();

  return params;
}

/**
 * Returns the effective entity ID from route params. Resolution order:
 * 1. `childModuleId` — entity inside a container
 * 2. `moduleId` — entity is a direct child of a tab
 * 3. `tabId` — the tab itself is an entity (no moduleId in URL)
 */
export const getEffectiveEntityId = (params: {
  tabId?: string;
  moduleId?: string;
  childModuleId?: string;
}): string | undefined =>
  params.childModuleId || params.moduleId || params.tabId;
